export var SahhaEnvironment;
(function (SahhaEnvironment) {
    SahhaEnvironment["development"] = "development";
    SahhaEnvironment["sandbox"] = "sandbox";
    SahhaEnvironment["production"] = "production";
})(SahhaEnvironment || (SahhaEnvironment = {}));
export var SahhaSensor;
(function (SahhaSensor) {
    SahhaSensor["gender"] = "gender";
    SahhaSensor["date_of_birth"] = "date_of_birth";
    SahhaSensor["sleep"] = "sleep";
    SahhaSensor["steps"] = "steps";
    SahhaSensor["floors_climbed"] = "floors_climbed";
    SahhaSensor["heart_rate"] = "heart_rate";
    SahhaSensor["resting_heart_rate"] = "resting_heart_rate";
    SahhaSensor["walking_heart_rate_average"] = "walking_heart_rate_average";
    SahhaSensor["heart_rate_variability_sdnn"] = "heart_rate_variability_sdnn";
    SahhaSensor["heart_rate_variability_rmssd"] = "heart_rate_variability_rmssd";
    SahhaSensor["blood_pressure_systolic"] = "blood_pressure_systolic";
    SahhaSensor["blood_pressure_diastolic"] = "blood_pressure_diastolic";
    SahhaSensor["blood_glucose"] = "blood_glucose";
    SahhaSensor["vo2_max"] = "vo2_max";
    SahhaSensor["oxygen_saturation"] = "oxygen_saturation";
    SahhaSensor["respiratory_rate"] = "respiratory_rate";
    SahhaSensor["active_energy_burned"] = "active_energy_burned";
    SahhaSensor["basal_energy_burned"] = "basal_energy_burned";
    SahhaSensor["total_energy_burned"] = "total_energy_burned";
    SahhaSensor["basal_metabolic_rate"] = "basal_metabolic_rate";
    SahhaSensor["time_in_daylight"] = "time_in_daylight";
    SahhaSensor["body_temperature"] = "body_temperature";
    SahhaSensor["basal_body_temperature"] = "basal_body_temperature";
    SahhaSensor["sleeping_wrist_temperature"] = "sleeping_wrist_temperature";
    SahhaSensor["height"] = "height";
    SahhaSensor["weight"] = "weight";
    SahhaSensor["lean_body_mass"] = "lean_body_mass";
    SahhaSensor["body_mass_index"] = "body_mass_index";
    SahhaSensor["body_fat"] = "body_fat";
    SahhaSensor["body_water_mass"] = "body_water_mass";
    SahhaSensor["bone_mass"] = "bone_mass";
    SahhaSensor["waist_circumference"] = "waist_circumference";
    SahhaSensor["stand_time"] = "stand_time";
    SahhaSensor["move_time"] = "move_time";
    SahhaSensor["exercise_time"] = "exercise_time";
    SahhaSensor["activity_summary"] = "activity_summary";
    SahhaSensor["device_lock"] = "device_lock";
    SahhaSensor["exercise"] = "exercise";
    SahhaSensor["running_speed"] = "running_speed";
    SahhaSensor["running_power"] = "running_power";
    SahhaSensor["running_ground_contact_time"] = "running_ground_contact_time";
    SahhaSensor["running_stride_length"] = "running_stride_length";
    SahhaSensor["running_vertical_oscillation"] = "running_vertical_oscillation";
    SahhaSensor["six_minute_walk_test_distance"] = "six_minute_walk_test_distance";
    SahhaSensor["stair_ascent_speed"] = "stair_ascent_speed";
    SahhaSensor["stair_descent_speed"] = "stair_descent_speed";
    SahhaSensor["walking_speed"] = "walking_speed";
    SahhaSensor["walking_steadiness"] = "walking_steadiness";
    SahhaSensor["walking_asymmetry_percentage"] = "walking_asymmetry_percentage";
    SahhaSensor["walking_double_support_percentage"] = "walking_double_support_percentage";
    SahhaSensor["walking_step_length"] = "walking_step_length";
    SahhaSensor["energy_consumed"] = "energy_consumed";
})(SahhaSensor || (SahhaSensor = {}));
export var SahhaSensorStatus;
(function (SahhaSensorStatus) {
    SahhaSensorStatus[SahhaSensorStatus["pending"] = 0] = "pending";
    SahhaSensorStatus[SahhaSensorStatus["unavailable"] = 1] = "unavailable";
    SahhaSensorStatus[SahhaSensorStatus["disabled"] = 2] = "disabled";
    SahhaSensorStatus[SahhaSensorStatus["enabled"] = 3] = "enabled";
})(SahhaSensorStatus || (SahhaSensorStatus = {}));
export var SahhaScoreType;
(function (SahhaScoreType) {
    SahhaScoreType["wellbeing"] = "wellbeing";
    SahhaScoreType["activity"] = "activity";
    SahhaScoreType["sleep"] = "sleep";
    SahhaScoreType["readiness"] = "readiness";
    SahhaScoreType["mental_wellbeing"] = "mental_wellbeing";
})(SahhaScoreType || (SahhaScoreType = {}));
export var SahhaBiomarkerCategory;
(function (SahhaBiomarkerCategory) {
    SahhaBiomarkerCategory["activity"] = "activity";
    SahhaBiomarkerCategory["body"] = "body";
    SahhaBiomarkerCategory["characteristic"] = "characteristic";
    SahhaBiomarkerCategory["reproductive"] = "reproductive";
    SahhaBiomarkerCategory["sleep"] = "sleep";
    SahhaBiomarkerCategory["vitals"] = "vitals";
})(SahhaBiomarkerCategory || (SahhaBiomarkerCategory = {}));
export var SahhaBiomarkerType;
(function (SahhaBiomarkerType) {
    SahhaBiomarkerType["steps"] = "steps";
    SahhaBiomarkerType["floors_climbed"] = "floors_climbed";
    SahhaBiomarkerType["active_hours"] = "active_hours";
    SahhaBiomarkerType["active_duration"] = "active_duration";
    SahhaBiomarkerType["activity_low_intensity_duration"] = "activity_low_intensity_duration";
    SahhaBiomarkerType["activity_mid_intensity_duration"] = "activity_mid_intensity_duration";
    SahhaBiomarkerType["activity_high_intensity_duration"] = "activity_high_intensity_duration";
    SahhaBiomarkerType["activity_sedentary_duration"] = "activity_sedentary_duration";
    SahhaBiomarkerType["active_energy_burned"] = "active_energy_burned";
    SahhaBiomarkerType["total_energy_burned"] = "total_energy_burned";
    SahhaBiomarkerType["height"] = "height";
    SahhaBiomarkerType["weight"] = "weight";
    SahhaBiomarkerType["body_mass_index"] = "body_mass_index";
    SahhaBiomarkerType["body_fat"] = "body_fat";
    SahhaBiomarkerType["fat_mass"] = "fat_mass";
    SahhaBiomarkerType["lean_mass"] = "lean_mass";
    SahhaBiomarkerType["waist_circumference"] = "waist_circumference";
    SahhaBiomarkerType["resting_energy_burned"] = "resting_energy_burned";
    SahhaBiomarkerType["age"] = "age";
    SahhaBiomarkerType["biological_sex"] = "biological_sex";
    SahhaBiomarkerType["date_of_birth"] = "date_of_birth";
    SahhaBiomarkerType["menstrual_cycle_length"] = "menstrual_cycle_length";
    SahhaBiomarkerType["menstrual_cycle_start_date"] = "menstrual_cycle_start_date";
    SahhaBiomarkerType["menstrual_cycle_end_date"] = "menstrual_cycle_end_date";
    SahhaBiomarkerType["menstrual_phase"] = "menstrual_phase";
    SahhaBiomarkerType["menstrual_phase_start_date"] = "menstrual_phase_start_date";
    SahhaBiomarkerType["menstrual_phase_end_date"] = "menstrual_phase_end_date";
    SahhaBiomarkerType["menstrual_phase_length"] = "menstrual_phase_length";
    SahhaBiomarkerType["sleep_start_time"] = "sleep_start_time";
    SahhaBiomarkerType["sleep_end_time"] = "sleep_end_time";
    SahhaBiomarkerType["sleep_duration"] = "sleep_duration";
    SahhaBiomarkerType["sleep_debt"] = "sleep_debt";
    SahhaBiomarkerType["sleep_interruptions"] = "sleep_interruptions";
    SahhaBiomarkerType["sleep_in_bed_duration"] = "sleep_in_bed_duration";
    SahhaBiomarkerType["sleep_awake_duration"] = "sleep_awake_duration";
    SahhaBiomarkerType["sleep_light_duration"] = "sleep_light_duration";
    SahhaBiomarkerType["sleep_rem_duration"] = "sleep_rem_duration";
    SahhaBiomarkerType["sleep_deep_duration"] = "sleep_deep_duration";
    SahhaBiomarkerType["sleep_regularity"] = "sleep_regularity";
    SahhaBiomarkerType["sleep_latency"] = "sleep_latency";
    SahhaBiomarkerType["sleep_efficiency"] = "sleep_efficiency";
    SahhaBiomarkerType["heart_rate_resting"] = "heart_rate_resting";
    SahhaBiomarkerType["heart_rate_sleep"] = "heart_rate_sleep";
    SahhaBiomarkerType["heart_rate_variability_sdnn"] = "heart_rate_variability_sdnn";
    SahhaBiomarkerType["heart_rate_variability_rmssd"] = "heart_rate_variability_rmssd";
    SahhaBiomarkerType["respiratory_rate"] = "respiratory_rate";
    SahhaBiomarkerType["respiratory_rate_sleep"] = "respiratory_rate_sleep";
    SahhaBiomarkerType["oxygen_saturation"] = "oxygen_saturation";
    SahhaBiomarkerType["oxygen_saturation_sleep"] = "oxygen_saturation_sleep";
    SahhaBiomarkerType["vo2_max"] = "vo2_max";
    SahhaBiomarkerType["blood_glucose"] = "blood_glucose";
    SahhaBiomarkerType["blood_pressure_systolic"] = "blood_pressure_systolic";
    SahhaBiomarkerType["blood_pressure_diastolic"] = "blood_pressure_diastolic";
    SahhaBiomarkerType["body_temperature_basal"] = "body_temperature_basal";
    SahhaBiomarkerType["skin_temperature_sleep"] = "skin_temperature_sleep";
})(SahhaBiomarkerType || (SahhaBiomarkerType = {}));
//# sourceMappingURL=definitions.js.map